import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { CalendarTokenClientV2Base } from './CalendarTokenClientV2Base';
import { createCalendarToken, deleteCalendarToken, getCalendarToken, queryCalendarTokens, updateCalendarToken } from './generated/CalendarTokenClientV2/calendarTokenHttpRequests';
export class CalendarTokenClientV2 extends HttpBaseClient(CalendarTokenClientV2Base) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getCalendarTokenImpl", getCalendarToken);
    _defineProperty(this, "queryCalendarTokensImpl", queryCalendarTokens);
    _defineProperty(this, "createCalendarTokenImpl", createCalendarToken);
    _defineProperty(this, "updateCalendarTokenImpl", updateCalendarToken);
    _defineProperty(this, "deleteCalendarTokenImpl", deleteCalendarToken);
  }
}
//# sourceMappingURL=CalendarTokenClientV2Http.js.map